import { DynamicSearchFiltersDrawer } from '@/features/shop/components/Drawer/SearchFiltersDrawer/DynamicSearchFiltersDrawer'
import { DynamicSearchFilterModal } from '@/features/shop/components/Modal/SearchFilterModal/DynamicSearchFilterModal'
import { FilterPill } from '@/features/shop/components/ProductFilter/FilterOptions/FilterPill'
import { useMediaQuery } from '@/features/shared/hooks/useMediaQuery'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'

export const AllFiltersOption = () => {
  const { openDialog } = useHandleDialog()
  const { screenSm } = useMediaQuery()

  const handleOnClick = () => {
    screenSm
      ? openDialog(DynamicSearchFilterModal, { filterToAutoExpand: '' })
      : openDialog(DynamicSearchFiltersDrawer)
  }
  return <FilterPill onClick={handleOnClick}>All filters</FilterPill>
}
